import {
  FilterGroupType,
  FilterOption,
  FilterOptionAttribute,
  FilterOptionEvent,
  FilterOptionField,
  FilterSetup,
  FilterType,
} from '@services/core-services/filters';

const getIcon = (type: string): string => {
  switch (type) {
    case 'string':
      return 'mingcute_text_fill';
    case 'datetime':
      return 'calendar';
    case 'list':
      return 'list';
    case 'number':
      return 'array';
    case 'boolean':
      return 'boolean';
    case 'json':
      return 'object_icon';
    default:
      return 'string_text';
  }
};

const getFilterType = (type: string): FilterType => {
  switch (type) {
    case 'string':
    case 'String':
      return FilterType.String;
    case 'datetime':
      return FilterType.Date;
    case 'boolean':
    case 'bool':
      return FilterType.Boolean;
    case 'list':
      return FilterType.Source;
    case 'number':
      return FilterType.Number;
    case 'json':
      return FilterType.String;
    default:
      return FilterType.String;
  }
};

const getFilterGroup = (input: string) => {
  switch (input) {
    case 'events':
      return FilterGroupType.Events;
    case 'attributes':
      return FilterGroupType.Attributes;
    default:
      return FilterGroupType.Data;
  }
};

const mapFields = (field: FilterOptionField) => {
  return {
    icon: getIcon(field.data_type),
    field: field.name,
    type: getFilterType(field.data_type),
    label: field.label,
    filterable: field.filterable,
    sortable: field.sortable,
    group: getFilterGroup('fields'),
    source: field.value?.map(({ label, value }: any) => ({ key: value, value: label })),
  };
};

const mapAttributes = (field: FilterOptionAttribute) => {
  return {
    icon: getIcon(field.data_type),
    field: field.name,
    type: getFilterType(field.data_type?.toLowerCase()),
    label: field.label,
    filterable: field.filterable,
    sortable: field.sortable,
    group: getFilterGroup('attributes'),
    source: field.value?.map(({ label, value }: any) => ({ key: value, value: label })),
  };
};

const mapEvents = (field: FilterOptionEvent) => {
  return {
    id: field.id,
    icon: getIcon('string'),
    field: field.event_name,
    type: FilterType.String,
    label: field.event_name,
    filterable: true,
    sortable: true,
    group: getFilterGroup('events'),
  };
};

export const getFilterSetupFromOption = (option: FilterOption): FilterSetup => {
  return {
    entries: [
      ...option.fields.map(mapFields),
      ...option.attributes.map(mapAttributes),
      ...option.events.map(mapEvents),
    ],
  };
};
